export const initialState = {
  profilInfo: '',
  insuranceListing: '',
  programContacts: '',
  statusAndMsg: null,
  allowDonorPhotoUpload: true
};
